export const BLOG_REQUESTS_ADDRESS = '/blog-requests';
export const BLOG_REQUEST_ADD_ADDRESS = '/blog-requests/add';
export const BLOG_REQUEST_ADD_EMAIL_VERIFICATION_ADDRESS = '/blog-requests/add/email-validation';

export const ADMIN_LOGIN_ADDRESS = '/admin/login';
export const ADMIN_BLOG_REQUESTS_ADDRESS = '/admin/blog-requests';
export const ADMIN_RECOMMENDED_POSTS_ADDRESS = '/admin/recommended-posts';

export const NOT_FOUND_ADDRESS = '/404-not-found';

export function getGoAddress(originalLink) {
    return '/go?from=website&link=' + encodeURIComponent(originalLink);
}

export function getBlogAddress(domainName) {
    return `/blogs/${domainName}`;
}

export function getAbstractAddress(originalLink) {
    return `/abstract?link=${encodeURIComponent(originalLink)}`;
}

export function getSharingAddress(originalLink) {
    return `/sharing?link=${encodeURIComponent(originalLink)}`;
}

export function getBlogRequestAddress(id) {
    return `/blog-requests/${id}`;
}

export function getGravatarImageFullURL(imageURL) {
    // 如果 imageURL 已经是完整的 URL，直接返回
    if (imageURL && (imageURL.startsWith('http://') || imageURL.startsWith('https://'))) {
    return imageURL;
    }
    
    // 如果 imageURL 是相对路径，添加域名前缀
    if (imageURL && imageURL.startsWith('/')) {
        return `https://bokehub.com${imageURL}`;
    }
    
    // 如果 imageURL 为空或无效，返回默认头像
    return 'https://bokehub.com/gravatar/ccd670b883d4ac11d698c380668529de?size=40';
}

export function getAdminBlogRequestAddress(id) {
    return `/admin/blog-requests/${id}`;
}